import React from 'react';
import './App.css';
import Navbar from "./components/NavBar";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import About from './pages/aboutMe';
import Certifications from './pages/certifications';
import Resume from './pages/resume';
import Projects from './pages/projects';
import Home from './pages/home';








function App() {
return (

	<Router>
		<Navbar/>
		<Routes>
		<Route path='/'  element ={<About/>}></Route>
		<Route path='/aboutMe'  element ={<Home/>}></Route>
		<Route path='/projects'  element ={<Projects/>}></Route>
		<Route path='/resume' element ={<Resume/>}></Route>
		<Route path='/certifications' element ={<Certifications/>}></Route>
		</Routes>
		
	</Router>

);
}

export default App;
